import { useTranslation } from "react-i18next";
import { SkeletonStatus } from "@/components/Skeleton";

// Shown while a page's code or access check loads. It only holds the space: each page shows
// its own skeleton once it renders, so loading never shows two placeholders in a row.
export default function SkeletonLoader() {
  const { t } = useTranslation();

  return (
    <div aria-busy="true" className="min-h-[60vh]">
      <SkeletonStatus label={t("loading")} />
    </div>
  );
}
